export const maxLocationNameLength = 50;
